import script from "./IfcClassVisibilityBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./IfcClassVisibilityBar.vue?vue&type=script&setup=true&lang=ts"

import "./IfcClassVisibilityBar.vue?vue&type=style&index=0&id=03a24574&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03a24574"]])

export default __exports__